import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Stamp, RefreshCw } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { api, errMsg } from "@/lib/api";

export function AdminWatermark() {
  const [s, setS] = useState(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const load = () =>
    api.get("/admin/settings").then((r) => {
      setS(r.data);
      setText((t) => t || r.data.watermark);
    });
  useEffect(() => { load(); }, []);

  const running = s && s.regen_total > 0 && s.regen_done < s.regen_total;
  useEffect(() => {
    if (!running) return;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [running]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings/watermark", { text });
      setS(data);
      toast.success("Marca d'água atualizada. Aplicando nas fotos…");
      setTimeout(load, 1500);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  if (!s) return <p className="mt-6 text-zinc-500">Carregando…</p>;

  return (
    <form onSubmit={save} className="mt-6 bg-white border border-zinc-200 rounded-lg p-6 max-w-xl" data-testid="admin-watermark">
      <Stamp className="w-6 h-6 text-[#0055FF]" />
      <h3 className="mt-3 font-display font-bold text-xl">Texto da marca d'água</h3>
      <p className="mt-1 text-sm text-zinc-600">Aparece junto do emblema azul em todas as fotos antes da compra. Ex: seu nome ou o nome do seu estúdio.</p>
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        maxLength={24}
        minLength={2}
        required
        data-testid="watermark-text-input"
        className="mt-4 w-full h-12 px-3 rounded-md border border-zinc-200 font-display font-bold text-lg focus:outline-none focus:ring-2 focus:ring-[#0055FF]"
      />
      <div className="mt-4 rounded-md bg-zinc-800 p-5 flex items-center gap-3 overflow-hidden" data-testid="watermark-preview">
        <span className="w-10 h-10 shrink-0 rounded-lg bg-[#0055FF]/80" />
        <span className="font-display font-black text-2xl text-white/80 truncate">{text || " "}</span>
      </div>
      {running && (
        <div className="mt-4" data-testid="watermark-progress">
          <Progress value={(s.regen_done / s.regen_total) * 100} />
          <p className="mt-2 text-sm text-zinc-600 flex items-center gap-2"><RefreshCw className="w-4 h-4 animate-spin" /> Atualizando fotos: {s.regen_done} de {s.regen_total}</p>
        </div>
      )}
      <button disabled={saving || text.trim() === s.watermark} data-testid="watermark-save-btn" className="mt-5 h-12 px-6 rounded-md bg-[#0055FF] hover:bg-[#0040CC] disabled:opacity-50 text-white font-semibold">
        {saving ? "Salvando…" : "Salvar e aplicar em todas as fotos"}
      </button>
    </form>
  );
}
